import React, { useRef, useEffect } from 'react';
import { draggable } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';

function MessageItem({ message }) {
    const cardRef = useRef(null);

    const isMobileCustomDrag = typeof window !== 'undefined' &&  (/android|iphone|kindle|ipad/i.test(navigator.userAgent.toLowerCase()));
    const startY = React.useRef(0);
    const isDragging = React.useRef(false);
    const mobileHandlers = isMobileCustomDrag ? {
        onPointerDown: (e) => {
            e.stopPropagation();
            startY.current = e.clientY;
            isDragging.current = true;
            e.currentTarget.setPointerCapture(e.pointerId);
            
            if (cardRef.current) {
                cardRef.current.style.transition = 'none';
                // cardRef.current.style.zIndex = '9999';
                cardRef.current.style.opacity = '0.8';
                cardRef.current.style.zIndex = '29999';
                cardRef.current.style.willChange = 'transform';
                cardRef.current.style.position = 'relative';
                cardRef.current.style.backgroundColor = 'inherit';
            }
        },
        onPointerMove: (e) => {
            if (!isDragging.current || !cardRef.current) return;

            const diffY = e.clientY - startY.current;
            cardRef.current.style.transform = `translateY(${diffY}px)`;
            const inputArea = document.getElementById('Encrypted');
            if (inputArea) {
                const rect = inputArea.getBoundingClientRect();
                const isOver = e.clientY >= rect.top && e.clientY <= rect.bottom;
                
                if (isOver) {
                    inputArea.style.backgroundColor = 'rgba(76, 175, 80, 0.2)';
                    inputArea.style.borderColor = '#4CAF50';
                    inputArea._manualDropHandler(message.content);
                } else {
                    inputArea.style.backgroundColor = '';
                    inputArea.style.borderColor = '';
                }
            }
        },
        onPointerUp: (e) => {
            isDragging.current = false;
            e.currentTarget.releasePointerCapture(e.pointerId);
            const inputArea = document.getElementById('Encrypted');
            console.log("inputArea = ", inputArea);
            if (inputArea) {
                const rect = inputArea.getBoundingClientRect();
                const isOver = (
                    e.clientX >= rect.left - 10 &&
                    e.clientX <= rect.right + 10 &&
                    e.clientY >= rect.top - 10 &&
                    e.clientY <= rect.bottom + 10
                );
                if (isOver) {
                    if (typeof inputArea._manualDropHandler === 'function') {
                        // inputArea._manualDropHandler(message.content);
                    }
                }
            }
            if (cardRef.current) {
                cardRef.current.style.transition = 'transform 0.3s ease';
                cardRef.current.style.transform = 'translateY(0)';
                cardRef.current.style.zIndex = '';
                cardRef.current.style.opacity = '1';
                cardRef.current.style.willChange = 'auto';
                // cardRef.current.style.backgroundColor = 'inherit';
                // cardRef.current.style.padding = '4px 8px';
                // cardRef.current.style.borderRadius = 'inherit';
            }
        }
    } : {}; 
   

    useEffect(() => {
        const cardEl = cardRef.current;
        if (!cardEl) return;
        const cleanupFn = draggable({
            element: cardEl,
            getInitialData: () => ({
                type: "message",
                content: message.content,
                id: message._id
            }),
        });
        return () => cleanupFn();
    }, [message.content, message._id]);
    
    return (
        <span   className="touch_action" 
                style={{ display: "flex" }} 
                key={message._id} 
                onContextMenu={(e) => {
                    if (isMobileCustomDrag) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                }}
                onTouchStart={(e) => {
                    if (isMobileCustomDrag) {
                        e.stopPropagation();
                    }
                }}
        >
            <span
                className="message_content"
                ref={cardRef}
                data-is-draggable="true"
                
                draggable={! isMobileCustomDrag} 
                onDragStart={(e) => {
                    if (! isMobileCustomDrag) e.dataTransfer.setData("text/plain", message.content);
                }}
                {...mobileHandlers}
                style={{ 
                    touchAction:  isMobileCustomDrag ? "none" : "auto", 
                    WebkitTouchCallout:  isMobileCustomDrag ? 'none' : 'default' 
                }}
            >
                {message.content}
            </span>
        </span>
    );
};

export default MessageItem;